export default __webpack_public_path__ + "static/media/allianceIcon.f9ae9b22.png";